import { render, staticRenderFns } from "./LegacyRoleFilters.vue?vue&type=template&id=3a23d6f0&scoped=true&lang=html&"
import script from "./LegacyRoleFilters.vue?vue&type=script&lang=js&"
export * from "./LegacyRoleFilters.vue?vue&type=script&lang=js&"
import style0 from "./LegacyRoleFilters.vue?vue&type=style&index=0&id=3a23d6f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23d6f0",
  null
  
)

export default component.exports